import { Clickable, Col, Row, Sidepanel, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import RewardTypeForm from './RewardTypeForm';

const RewardTypeDetailPanel = ({ visible, closeModal, team, item, onSuccess }) => {
  const handleSuccess = () => {
    onSuccess?.();
    closeModal();
  };

  if (!item) return null;

  return (
    <Sidepanel pad="24px 0" wid={600} visible={visible} closeModal={closeModal}>
      <Col>
        <Row pad="0 24px 24px" start center>
          <Clickable onClick={closeModal}>
            <FiArrowLeft size={20} style={{ marginRight: 12 }} />
          </Clickable>
          <Col>
            <Text h3>Edit Reward Type</Text>
            <Text c1 col={theme.GREY_60}>{item.name}</Text>
          </Col>
        </Row>

        <RewardTypeForm
          team={team}
          initialData={item}
          isEditing={true}
          onSuccess={handleSuccess}
          onCancel={closeModal}
        />
      </Col>
    </Sidepanel>
  );
};

export default RewardTypeDetailPanel;
